import React from 'react';
import { Box, Text, Loader } from '@acast/decibel';
import moment from 'moment';
import Episode from 'client/resources/episode';
import EpisodePublishHistory from 'client/resources/episode-publish-history';
import resourceProp from 'shared/helpers/resource-prop';
import PublishedAlert from './published-alert';
import ScheduledAlert from './scheduled-alert';

const getLatestEntry = history => {
  return (
    history.data &&
    history.data.items
      .slice(0)
      .sort((a, b) => {
        const aCreated = moment(a.created);
        const bCreated = moment(b.created);

        if (aCreated.isAfter(bCreated)) {
          return -1;
        }
        if (bCreated.isAfter(aCreated)) {
          return 1;
        }

        return 0;
      })
      .shift()
  );
};

const getPendingMessage = () => (
  <Box gap={4} mb={4} alignItems="center">
    <Loader width={8} />
    <Text variant="caption" mb={0}>
      Checking publish state...
    </Text>
  </Box>
);

const PublishStateMessage = ({ episode, publishHistory }) => {
  if (publishHistory.pending) {
    return getPendingMessage();
  }

  if (episode.data.publishedOn === null) {
    return null;
  }

  const entry = getLatestEntry(publishHistory);

  if (!entry) {
    return null;
  }

  const { publishDate } = entry.acast;
  const isQueued = new Date(publishDate).getTime() > Date.now();

  if (isQueued) {
    return (
      <Box flexDirection="column" mb={4}>
        <ScheduledAlert date={publishDate} />
      </Box>
    );
  }

  return (
    <Box flexDirection="column" mb={4}>
      <PublishedAlert date={publishDate} />
    </Box>
  );
};

PublishStateMessage.propTypes = {
  episode: resourceProp(Episode),
  publishHistory: resourceProp(EpisodePublishHistory),
};

const withPublishHistory = EpisodePublishHistory.connect('publishHistory', 'episode.data.id');

export default withPublishHistory(PublishStateMessage);
